import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {AdKpiComponent} from "../page/ad-overview-page/components/kpiComponent/ad-kpi.component";
import {AdStatisticsComponent} from "../page/ad-overview-page/components/statisticsComponent/ad-statistics.component";
import {AdOverviewPage} from "../page/ad-overview-page/ad-overview.page";
import {AdConfigPage} from "../page/overview/ad-config/ad-config.page";


const adModuleEntry: TestModuleDefinition = {
    key: 'ad',
    label: 'Address (ad)',
    components: [
        {
            key: 'AdKpiComponent',
            component: AdKpiComponent,
            selector: 'ad-kpi-component',
            type: 'Component',
            label: 'ad kpi component'
        },
        {
            key: 'AdStatisticsComponent',
            component: AdStatisticsComponent,
            selector: 'ad-statistics-component',
            type: 'Component',
            label: 'ad statistics component'
        },
        {
            key: 'AdOverviewPage',
            component: AdOverviewPage,
            selector: 'mvs-example',
            type: 'PageComponent',
            label: 'ad overview page'
        },
        {
            key: 'AdConfigPage',
            component: AdConfigPage,
            selector: 'mvs-ad-config-page',
            type: 'PageComponent',
            label: 'ad config page'
        }
    ]
}

export const AD_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: adModuleEntry, multi: true}
];